"use strict";

exports.__esModule = true;
exports.propEntryMaker = void 0;
var _errors = require("../../common/errors");
var _config = require("../../entities/config");
var _record = require("../../entities/record");
var _schema = require("../../entities/schema");
var _value = require("../../entities/value");
const propEntryMaker = getValueEntry => ({
  schema,
  referencedSchemas,
  currentRecord,
  connection
}, dependencies) => {
  if (currentRecord) {
    const valueData = getValueData({
      schema,
      currentRecord,
      referencedSchemas,
      connection
    }, dependencies);
    if (shouldSetValue(dependencies.config, valueData.value)) {
      return getValueEntry({
        valueData,
        connection
      }, dependencies);
    }
  }
  return undefined;
};
exports.propEntryMaker = propEntryMaker;
const getValueData = ({
  schema,
  currentRecord,
  referencedSchemas,
  connection: {
    expression,
    fieldName
  }
}, dependencies) => expression ? evaluateExpression({
  expression,
  schema,
  currentRecord
}, dependencies) : getFieldData({
  fieldName,
  schema,
  referencedSchemas,
  currentRecord
}, dependencies);
const shouldSetValue = (config, value) => !(_config.Config.isLivePreviewEnabled(config) && _value.Value.isEmpty(value));
const evaluateExpression = ({
  expression,
  schema,
  currentRecord
}, {
  dataExpression,
  errorReporter
}) => {
  try {
    const {
      value,
      type
    } = dataExpression.evaluate({
      expression,
      variables: populateEmptyBooleanFields(currentRecord, schema)
    });
    return {
      value,
      type,
      fieldType: undefined
    };
  } catch (error) {
    errorReporter.report(_errors.CoreError.of('Failed to evaluate expression', {
      cause: error
    }));
    return {
      value: '',
      type: undefined,
      fieldType: undefined
    };
  }
};
const getFieldData = ({
  currentRecord,
  fieldName,
  schema,
  referencedSchemas
}, {
  errorReporter
}) => {
  const [rootFieldName, referencedFieldName] = fieldName.split('.');
  if (referencedFieldName) {
    const referencedCollectionId = _schema.Schema.getReferencedCollectionId(schema, rootFieldName);
    const referencedSchema = referencedCollectionId && referencedSchemas.find(({
      id
    }) => id === referencedCollectionId);
    if (!referencedSchema) {
      errorReporter.report(_errors.CoreError.of('Referenced schema not found'));
    }
    return makeFieldData({
      record: currentRecord[rootFieldName] ?? {},
      fieldName: referencedFieldName,
      schema: referencedSchema ?? _schema.Schema.make()
    });
  }
  return makeFieldData({
    schema,
    record: currentRecord,
    fieldName: rootFieldName
  });
};
const populateEmptyBooleanFields = (record, schema) => {
  const updatedRecord = {};
  for (const [fieldName, value] of Object.entries(record)) {
    updatedRecord[fieldName] = _schema.Schema.isFieldOfType(schema, fieldName, 'boolean') && _value.Value.isEmpty(value) ? false : value;
  }
  return updatedRecord;
};
const makeFieldData = ({
  record,
  fieldName,
  schema
}) => ({
  value: _record.Record.getValue(record, fieldName),
  fieldType: _schema.Schema.getFieldType(schema, fieldName)
});
//# sourceMappingURL=prop-entry-maker.js.map